import {DepartureRole} from 'app/permissions/types';

export interface RoleMetadata {
  displayName: string;
  singularName?: string;
  multi?: boolean;
  matHint?: string;
  heStaff: boolean;
  order: number;
  enumName: string;
}

export const ROLE_METADATA: Record<DepartureRole, RoleMetadata> = {
  designers: {
    displayName: 'Designers',
    singularName: 'Designer',
    multi: true,
    heStaff: false,
    order: 1,
    enumName: 'DESIGNERS'
  },
  proposer: {
    displayName: 'Proposer',
    order: 2,
    heStaff: false,
    enumName: 'PROPOSER'
  },
  assignee: {
    displayName: 'Current assignee',
    order: 0,
    heStaff: false,
    enumName: 'ASSIGNEE'
  },
  projectManager: {
    displayName: 'NH Project manager',
    order: 3,
    heStaff: true,
    matHint: `Optional prior to 'PM Appraisal' - to be confirmed with the Designer's project team`,
    enumName: 'PROJECT_MANAGER'
  },
  ssp: {
    displayName: 'Specialist submission point',
    order: 4,
    heStaff: true,
    matHint: `Optional prior to 'DAS Admin Check' - to be confirmed by DAS Admin`,
    enumName: 'SSP'
  },
  technicalSpecialist: {
    displayName: 'Technical specialist',
    order: 5,
    heStaff: true,
    matHint: `Optional prior to 'Specialist Submission Point' - to be confirmed by SSP`,
    enumName: 'TECHNICAL_SPECIALIST'
  },
  additionalTechnicalReviewers: {
    displayName: 'Additional technical reviewers',
    singularName: 'Additional technical reviewer',
    multi: true,
    order: 6,
    heStaff: true,
    enumName: 'ADDITIONAL_TECHNICAL_REVIEWERS'
  },
  authorisingSignatory: {
    displayName: 'Authorising signatory',
    order: 7,
    heStaff: true,
    enumName: 'AUTHORISING_SIGNATORY'
  }
};
